module.exports = __webpack_public_path__ + "static/img/member11.dcde5ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member11.png
// module id = KNNV
// module chunks = 0